import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { hideNotification } from '../../actions';
import { areThereNotifications } from '../../functions';
import NotificationsTransition from '../NotificationsTransition';
import Notification from './Notification';
import { isMobileBrowser } from "../../../base/environment/utils";
const useStyles = makeStyles()(() => {
    return {
        backgroundContainer: {
            '&.is-mobile': {
                position: 'absolute',
                bottom: 0,
                width: '100%',
            }
        },
        background1: {
            '&.is-mobile': {
                background: 'linear-gradient(180deg, rgba(33, 33, 33, 0) 0%, rgba(33, 33, 33, 0.5) 100%)',
                height: '48px'
            }
        },
        background2: {
            '&.is-mobile': {
                background: 'linear-gradient(180deg, rgba(33, 33, 33, 0.5) 0%, rgba(33, 33, 33, 0.8) 100%)',
                height: '73px'
            }
        },
        background3: {
            '&.is-mobile': {
                background: 'linear-gradient(180deg, rgba(33, 33, 33, 0.8) 0%, rgba(33, 33, 33, 0.9) 100%)',
                height: '52px'
            }
        },
        background4: {
            '&.is-mobile': {
                background: 'rgba(33, 33, 33, 0.9)',
                height: '94px'
            }
        },
        container: {
            position: 'absolute',
            top: '12px',
            right: '12px',
            width: '316px',
            maxWidth: '100%',
            zIndex: 600,
            '&.is-mobile': {
                position: 'initial',
                top: '0px',
                right: '0px',
            },
        },
        containerPortal: {
            width: '100%',
            maxWidth: 'calc(100% - 32px)',
            '&.is-mobile': {
                maxWidth: '100%',
            },
        }
    };
});
const NotificationsContainer = ({ _iAmSipGateway, _notifications, dispatch, portal }) => {
    const { classes, cx } = useStyles();
    const isMobile = isMobileBrowser();
    const _onDismissed = useCallback((uid) => {
        dispatch(hideNotification(uid));
    }, []);
    if (_iAmSipGateway) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        (isMobile && _notifications.length > 0) && (React.createElement("div", { className: classes.backgroundContainer },
            React.createElement("div", { className: classes.background1 }),
            React.createElement("div", { className: classes.background2 }),
            React.createElement("div", { className: classes.background3 }),
            React.createElement("div", { className: classes.background4 }))),
        React.createElement("div", { className: cx(classes.container, {
                [classes.containerPortal]: portal
            }), id: 'notifications-container' },
            React.createElement(NotificationsTransition, null, _notifications.map(({ props, uid }, index) => {
                // для последних 5 показываем обычное уведомление
                if (index < 5) {
                    return (React.createElement(Notification, { key: uid, ...props, onDismissed: _onDismissed, uid: uid }));
                }
                // для всех остальных сразу вызываем _onDismissed и тоже «рисуем»,
                // но они тут же пропадут
                _onDismissed(uid);
                return (React.createElement(Notification, { key: uid, ...props, onDismissed: _onDismissed, uid: uid }));
            }) || null))));
};
/**
 * Maps (parts of) the Redux state to the associated props for this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const { notifications } = state['features/notifications'];
    const { iAmSipGateway } = state['features/base/config'];
    const { isOpen: isChatOpen } = state['features/chat'];
    const _visible = areThereNotifications(state);
    return {
        _iAmSipGateway: Boolean(iAmSipGateway),
        _isChatOpen: isChatOpen,
        _notifications: _visible ? notifications : []
    };
}
export default connect(_mapStateToProps)(NotificationsContainer);
